import React from 'react'
import Cocktail from './Cocktail'
import Loading from './Loading'
import { useGlobalContext } from '../context'

const CocktailList = () => {
  const { cocktails, loading } = useGlobalContext()
  console.log(cocktails.length)
  if (loading) {
    return <Loading />
  }

  if (cocktails.length < 1) {
    return (
      <h2 className='section-title'>
        no cocktails matched your search criteria
      </h2>
    )
  }

  return (
    <section className='section'>
      <h2 className='section-title'>cocktails</h2>
      <div className='cocktails-center'>
        {cocktails.map((item) => {
          const { id } = item
          return <Cocktail key={id} {...item} />
        })}
      </div>
    </section>
  )
}

export default CocktailList

// se loada rrirtorna il loading, se invece non stanno cocktails con quella ricerca vai di <h2 className='section-title'>no cocktails matched your search criteria</h2> altrimenti vai di

//   <section className='section'>
//     <h2 className='section-title'>cocktails</h2>
//     <div className='cocktails-center'>
// ...
//     </div>
//   </section>

// return (
// <section className='section'>
//         <h2 className='section-title'>cocktails</h2>
//         <div className='cocktails-center'>
// {test.map((item)=>{
//   const {id} = item
// return <Cocktail key={id} {...item}/>
// }
// </div>
// </section>
// }
